// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class SaveThirdPartyIdRequestModel {
    'thirdPartyId': string;
    'accountId': number;
    'caseId'?: number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof SaveThirdPartyIdRequestModel>> = [
        {
            "name":     "thirdPartyId",
            "baseName": "thirdPartyId",
            "type":     "string"
        },
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "number"
        },
        {
            "name":     "caseId",
            "baseName": "caseId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return SaveThirdPartyIdRequestModel.attributeTypeMap;
    }
}
